"use client";

import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import useRevealOnScroll from "../../hooks/useRevealOnScroll";
import "./Oneplatformsection.css";

export default function OnePlatformSection() {
  const { t } = useTranslation("landingPage");

  useRevealOnScroll();

  const track1Ref = useRef(null);
  const track2Ref = useRef(null);

  const featuresRaw = t("platform.features", { returnObjects: true });
  const features = Array.isArray(featuresRaw) ? featuresRaw : [];

  if (!features.length) {
    return null;
  }

  return (
    <section className="platform">
      <div className="container">
        <div className="platform__header reveal-on-scroll reveal-up">
          <p className="platform__label">{t("platform.label")}</p>

          <h2 className="platform__title">
            {t("platform.title.line1")}
            <br />
            <span className="platform__title-accent">
              {t("platform.title.line2")}
            </span>
          </h2>
        </div>
      </div>

      <div className="platform__banner reveal-on-scroll reveal-scale">
        <div className="platform__banner-inner">
          <div className="platform__banner-top-right reveal-on-scroll reveal-right">
            <button className="platform__cta" type="button">
              {t("common.getStarted")}
              <span className="platform__cta-icon">↗</span>
            </button>
          </div>

          <div className="platform__hero-text reveal-on-scroll reveal-left">
            <h3 className="platform__hero-title">
              {t("platform.heroTitle.line1")}
              <br />
              {t("platform.heroTitle.line2")}
            </h3>

            <p className="platform__hero-desc">{t("platform.heroDesc")}</p>
          </div>

          <div className="platform__ticker-wrap reveal-on-scroll reveal-up">
            <div
              className="platform__ticker platform__ticker--left"
              ref={track1Ref}
            >
              {[...features, ...features, ...features].map((f, i) => (
                <span key={i} className="platform__pill">
                  {f}
                </span>
              ))}
            </div>
          </div>

          <div className="platform__ticker-wrap reveal-on-scroll reveal-up">
            <div
              className="platform__ticker platform__ticker--right"
              ref={track2Ref}
            >
              {[...features, ...features, ...features].map((f, i) => (
                <span key={i} className="platform__pill">
                  {f}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}